import Swiper, { EffectFade, Lazy, Thumbs, Autoplay } from 'swiper';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

const thumbnailsSlider = new Swiper('.single-product-slider-thumbnails', {
    modules: [Autoplay],
    slidesPerView: 3,
    watchSlidesVisibility: true,
    spaceBetween: 16,
    autoplay: {
        delay: 5000,
    },
});

const singleProductSlider = new Swiper('.single-product-slider', {
    modules: [EffectFade, Lazy, Thumbs],
    effect: 'slide',
    thumbs: {
        swiper: thumbnailsSlider,
    },
    autoHeight: true,
    loop: true,
    preloadImages: true,
    watchSlidesVisibility: true,
    lazy: {
        preloaderClass: 'single-product-slider-preloader',
    },
});

// PhotoSwipe
const lightbox = new PhotoSwipeLightbox({
    gallery: '.single-product-slider',
    children: 'a',
    pswpModule: () => import('photoswipe'),
});
lightbox.init();